import * as React from 'react';
import { SVGProps } from 'react';

const IconPrinterFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 2a1 1 0 0 0-1 1v2h16V3a1 1 0 0 0-1-1H5ZM3 7a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h2v-6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H3Z" />
    <path d="M17 22H7v-9h10v9Z" />
  </svg>
);
export default IconPrinterFilledSizeM;
